import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { Category, CategoriesStorage } from '../documents';

@Injectable()
export class GeneralCategoriesResolver implements Resolve<Category[]> {

    constructor(private categoriesStorage: CategoriesStorage) { }

    public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Category[]> {
        return this.categoriesStorage.generalCategories;
    }
}